export default {
    description:
        'Connexion à Activix CRM. Le plus innovant des CRM ! Gérez sans effort vos demandes par Internet, appels et @.capitalize:lexicon.walkIn.singular, puis mesurez vos performances.',
};
